module.exports = __webpack_public_path__ + "svg/angle-down-big.svg?b5fce35c87eedd070eb4eb6ce2deda42";